module.exports = __webpack_public_path__ + "static/the-promise-of-a-pencil-345619886b5ed219a438364b18b46a78.jpg";